import { findCatalogFileEntry, findCatalogOperatorRow } from '@buxus/shared'
import { fetchSasBlob } from './operatorApi'
import { idbGetOperatorFile, idbPutOperatorFile } from './operatorFileIdb'
import { mimeTypeForExtension, normalizeFileExt } from './operatorFileOpen'

function typedBlob(blob: Blob, ext: string): Blob {
  const namingExt = normalizeFileExt(ext)
  const mime = namingExt
    ? mimeTypeForExtension(namingExt)
    : blob.type || 'application/octet-stream'
  if (blob.type === mime) return blob
  return new Blob([blob], { type: mime })
}

/**
 * Resolve an operator attachment blob: IndexedDB cache first, then catalog SAS fetch + cache.
 */
export async function resolveOperatorFileBlob(
  operatorId: string,
  operatorVersion: string | null | undefined,
  fileId: string,
  fileExt: string | undefined,
  catalog: ReadonlyArray<Record<string, unknown>> | null | undefined,
): Promise<Blob | null> {
  const version = operatorVersion?.trim()
  if (version) {
    const cached = await idbGetOperatorFile(operatorId, fileId, version, {
      ignored: true,
    })
    if (cached) return cached
  }

  const row = findCatalogOperatorRow(catalog, operatorId)
  const entry = findCatalogFileEntry(row, fileId, fileExt)
  if (!entry) return null

  const ext = normalizeFileExt(fileExt) || normalizeFileExt(entry.ext)
  const blob = typedBlob(await fetchSasBlob(entry.sas), ext)

  if (version) {
    try {
      await idbPutOperatorFile(operatorId, version, entry.id, ext, blob, {
        ignored: true,
      })
    } catch {
      // Best-effort cache only — still return the fetched blob for this session.
    }
  }

  return blob
}
